import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="popup-modal"
export default class extends Controller {
  static targets = ["modal", "title", "overlay"];

  connect() {
    this.isVisible = false;
  }

  showModal(event) {
    if (!this.hasModalTarget) return;

    const title = event.currentTarget.dataset.popupModalTitle;

    // Update modal content
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title;
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = "block";
    }

    this.modalTarget.style.display = "block";

    // Prevent body scrolling
    document.body.classList.add("popup-modal-open");

    this.isVisible = true;
  }

  hideModal() {
    if (!this.hasModalTarget) return;

    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = "none";
    }

    this.modalTarget.style.display = "none";

    // Re-enable body scrolling
    document.body.classList.remove("popup-modal-open");

    this.isVisible = false;
  }
}
